/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShipmentFinancesQueryVariables = {
    slug: string;
};
export type ShipmentFinancesQueryResponse = {
    readonly shipmentShow: {
        readonly slug: string;
        readonly " $fragmentRefs": FragmentRefs<"ShipmentRateCard_shipment" | "ShipmentFinanceDetails_shipment" | "ShipmentFinanceMetricCard_shipment" | "ShipmentSiblingCompositionCard_shipment" | "ShipmentCompanyCard_shipment" | "ShipmentFinanceActionCard_shipment">;
    };
};
export type ShipmentFinancesQuery = {
    readonly response: ShipmentFinancesQueryResponse;
    readonly variables: ShipmentFinancesQueryVariables;
};



/*
query ShipmentFinancesQuery(
  $slug: String!
) {
  shipmentShow(slug: $slug) {
    slug
    ...ShipmentRateCard_shipment
    ...ShipmentFinanceDetails_shipment
    ...ShipmentFinanceMetricCard_shipment
    ...ShipmentSiblingCompositionCard_shipment
    ...ShipmentCompanyCard_shipment
    ...ShipmentFinanceActionCard_shipment
    id
  }
}

fragment EntityAttachmentListItem_attachment on EntityAttachment {
  url
  downloadUrl
  name
  contentType
  previewUrl
  documentType
  roleVisibilities {
    role
    roleShortTitle
    roleTitle
    visible
  }
  uploadedAtDisplay
  uploadedAt
}

fragment EntityAttachmentListPreviewer_attachment on EntityAttachment {
  url
  downloadUrl
  name
  contentType
  previewUrl
  documentType
  entityType
  entitySlug
  attachmentSlug
  thumbnailImage
  ...EntityAttachmentRoleVisibility_attachment
}

fragment EntityAttachmentRoleVisibility_attachment on EntityAttachment {
  name
  attachmentSlug
  entityType
  entitySlug
  roleVisibilities {
    role
    roleShortTitle
    roleTitle
    visible
  }
}

fragment EntityAttachment_attachment on EntityAttachment {
  url
  downloadUrl
  name
  contentType
  previewUrl
  documentType
  draftTicketStatus
  lexOfficeInvoiceStatus
  signedStatus
  rejectReason
}

fragment KeyField_data on KeyField {
  label
  value {
    key
    ...SemanticString_data
  }
}

fragment SemanticString_data on SemanticString {
  text
}

fragment ShipmentCompanyCard_shipment on Shipment {
  slug
  company {
    eori
    eoriValid
    eoriValidatedAt
    vat
    vatValid
    vatValidatedAt
    id
  }
  eoriDocGeneratedAt
  vatDocGeneratedAt
}

fragment ShipmentFinanceActionCard_shipment on Shipment {
  slug
  shipmentType
  lexofficeInvoices {
    attachmentSlug
    name
    isImage
    documentType
    ...EntityAttachmentListPreviewer_attachment
    ...EntityAttachment_attachment
    ...EntityAttachmentListItem_attachment
    id
  }
  taxAssessments {
    attachmentSlug
    name
    isImage
    documentType
    ...EntityAttachmentListPreviewer_attachment
    ...EntityAttachment_attachment
    ...EntityAttachmentListItem_attachment
    id
  }
}

fragment ShipmentFinanceDetails_shipment on Shipment {
  slug
  stage
  shipmentType
  displayCustomsType
  freeWarehousingDays
  costWarehousingPerDay
  estimatedCostWarehousing
  estimatedRevenueWarehousing
  costWarehousing
  revenueWarehousing
  estimatedCustomsDuties
  customsDuties
  estimatedCustomsVat
  customsVat
  costDischarge
  revenueDischarge
  costTransport
  revenueTransport
  costExpenses
  revenueExpenses
  costCustomsInspection
  revenueCustomsInspection
  costClimaCertificate
  revenueClimaCertificate
  costOpinion
  revenueOpinion
  costContainerXray
  revenueContainerXray
  costContainerHandling
  revenueContainerHandling
  costShipping
  revenueShipping
  costCleaning
  revenueCleaning
  costSpecialHandling
  revenueSpecialHandling
  costStorage
  revenueStorage
  costOther
  costForklift
  revenueForklift
  revenueCustomsClearance
  costCustomsClearance
  discount
  discountRemark
  receivedPayment
  totalCustomsDutiesAndVat
  totalMiscRevenue
  totalMiscCost
  totalContainerRevenue
  totalContainerCost
  totalCost
  totalRevenue
  displayExpectedHandoverDate
  displayHandoverDate
  displayDischargeDate
  shipmentValue
  shippingCost
  shipmentValueCurrency
  shipmentTypeDetails {
    portHandlingCharge
    vatChargePercent
    dutiesRatePercent
  }
  container {
    displayTerminalDate
    costXray
    costStoragePlusDemurrage
    costCleaning
    warehouseContact {
      slug
      name
      freeWarehousingDays
      costWarehousingPerDay
      costShipmentDischarge
      id
    }
    id
  }
  rateCardContact {
    slug
    name
    rateCard {
      threePackCarDischarge
      forklift
      standardCustomsClearance
      specialHandling
      freeWarehousingDays
      costWarehousing
    }
    id
  }
  customer {
    slug
    vatWarehousing
    vatRevenues
    id
  }
}

fragment ShipmentFinanceMetricCard_shipment on Shipment {
  slug
  totalCost
  totalRevenue
  totalProfit
  shipmentTypeDetails {
    vatChargePercent
  }
  estimatedRevenueWarehousing
  vatCalculator
  lexofficeInvoiceAmountPaid
}

fragment ShipmentRateCard_shipment on Shipment {
  rateCardContact {
    name
    rateCardItem {
      title
      keyFields {
        key
        ...KeyField_data
      }
      id
    }
    id
  }
}

fragment ShipmentSiblingCompositionCard_shipment on Shipment {
  container {
    composition {
      totalShipments
      shipmentCountsByType {
        type
        typeLabel
        count
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "freeWarehousingDays",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "costWarehousing",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "costWarehousingPerDay",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "costCleaning",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "attachmentSlug",
    "storageKey": null
  },
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isImage",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "documentType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "downloadUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "contentType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "previewUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "entityType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "entitySlug",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "thumbnailImage",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RoleVisibility",
    "kind": "LinkedField",
    "name": "roleVisibilities",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roleShortTitle",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roleTitle",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "visible",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "draftTicketStatus",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lexOfficeInvoiceStatus",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signedStatus",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rejectReason",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uploadedAtDisplay",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uploadedAt",
    "storageKey": null
  },
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShipmentFinancesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Shipment",
        "kind": "LinkedField",
        "name": "shipmentShow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShipmentRateCard_shipment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShipmentFinanceDetails_shipment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShipmentFinanceMetricCard_shipment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShipmentSiblingCompositionCard_shipment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShipmentCompanyCard_shipment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShipmentFinanceActionCard_shipment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShipmentFinancesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Shipment",
        "kind": "LinkedField",
        "name": "shipmentShow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "rateCardContact",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SettingsItem",
                "kind": "LinkedField",
                "name": "rateCardItem",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "KeyField",
                    "kind": "LinkedField",
                    "name": "keyFields",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "label",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SemanticString",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactRateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "threePackCarDischarge",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forklift",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "standardCustomsClearance",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "specialHandling",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shipmentType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayCustomsType",
            "storageKey": null
          },
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimatedCostWarehousing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimatedRevenueWarehousing",
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueWarehousing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimatedCustomsDuties",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customsDuties",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimatedCustomsVat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customsVat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costDischarge",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueDischarge",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costTransport",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueTransport",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costExpenses",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueExpenses",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costCustomsInspection",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueCustomsInspection",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costClimaCertificate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueClimaCertificate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costOpinion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueOpinion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costContainerXray",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueContainerXray",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costContainerHandling",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueContainerHandling",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costShipping",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueShipping",
            "storageKey": null
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueCleaning",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costSpecialHandling",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueSpecialHandling",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costStorage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueStorage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costOther",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costForklift",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueForklift",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueCustomsClearance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "costCustomsClearance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discountRemark",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "receivedPayment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCustomsDutiesAndVat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalMiscRevenue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalMiscCost",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalContainerRevenue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalContainerCost",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCost",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalRevenue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayExpectedHandoverDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayHandoverDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayDischargeDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shipmentValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shippingCost",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shipmentValueCurrency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ShipmentTypeDetails",
            "kind": "LinkedField",
            "name": "shipmentTypeDetails",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "portHandlingCharge",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatChargePercent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dutiesRatePercent",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Container",
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayTerminalDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costXray",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costStoragePlusDemurrage",
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Contact",
                "kind": "LinkedField",
                "name": "warehouseContact",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costShipmentDischarge",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContainerComposition",
                "kind": "LinkedField",
                "name": "composition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalShipments",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentCountBy",
                    "kind": "LinkedField",
                    "name": "shipmentCountsByType",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "typeLabel",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "customer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatWarehousing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatRevenues",
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalProfit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vatCalculator",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lexofficeInvoiceAmountPaid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eori",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eoriValid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eoriValidatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatValid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatValidatedAt",
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eoriDocGeneratedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vatDocGeneratedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EntityAttachment",
            "kind": "LinkedField",
            "name": "lexofficeInvoices",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EntityAttachment",
            "kind": "LinkedField",
            "name": "taxAssessments",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4b32b106d15269a637395d37c4e88184",
    "id": null,
    "metadata": {},
    "name": "ShipmentFinancesQuery",
    "operationKind": "query",
    "text": "query ShipmentFinancesQuery(\n  $slug: String!\n) {\n  shipmentShow(slug: $slug) {\n    slug\n    ...ShipmentRateCard_shipment\n    ...ShipmentFinanceDetails_shipment\n    ...ShipmentFinanceMetricCard_shipment\n    ...ShipmentSiblingCompositionCard_shipment\n    ...ShipmentCompanyCard_shipment\n    ...ShipmentFinanceActionCard_shipment\n    id\n  }\n}\n\nfragment EntityAttachmentListItem_attachment on EntityAttachment {\n  url\n  downloadUrl\n  name\n  contentType\n  previewUrl\n  documentType\n  roleVisibilities {\n    role\n    roleShortTitle\n    roleTitle\n    visible\n  }\n  uploadedAtDisplay\n  uploadedAt\n}\n\nfragment EntityAttachmentListPreviewer_attachment on EntityAttachment {\n  url\n  downloadUrl\n  name\n  contentType\n  previewUrl\n  documentType\n  entityType\n  entitySlug\n  attachmentSlug\n  thumbnailImage\n  ...EntityAttachmentRoleVisibility_attachment\n}\n\nfragment EntityAttachmentRoleVisibility_attachment on EntityAttachment {\n  name\n  attachmentSlug\n  entityType\n  entitySlug\n  roleVisibilities {\n    role\n    roleShortTitle\n    roleTitle\n    visible\n  }\n}\n\nfragment EntityAttachment_attachment on EntityAttachment {\n  url\n  downloadUrl\n  name\n  contentType\n  previewUrl\n  documentType\n  draftTicketStatus\n  lexOfficeInvoiceStatus\n  signedStatus\n  rejectReason\n}\n\nfragment KeyField_data on KeyField {\n  label\n  value {\n    key\n    ...SemanticString_data\n  }\n}\n\nfragment SemanticString_data on SemanticString {\n  text\n}\n\nfragment ShipmentCompanyCard_shipment on Shipment {\n  slug\n  company {\n    eori\n    eoriValid\n    eoriValidatedAt\n    vat\n    vatValid\n    vatValidatedAt\n    id\n  }\n  eoriDocGeneratedAt\n  vatDocGeneratedAt\n}\n\nfragment ShipmentFinanceActionCard_shipment on Shipment {\n  slug\n  shipmentType\n  lexofficeInvoices {\n    attachmentSlug\n    name\n    isImage\n    documentType\n    ...EntityAttachmentListPreviewer_attachment\n    ...EntityAttachment_attachment\n    ...EntityAttachmentListItem_attachment\n    id\n  }\n  taxAssessments {\n    attachmentSlug\n    name\n    isImage\n    documentType\n    ...EntityAttachmentListPreviewer_attachment\n    ...EntityAttachment_attachment\n    ...EntityAttachmentListItem_attachment\n    id\n  }\n}\n\nfragment ShipmentFinanceDetails_shipment on Shipment {\n  slug\n  stage\n  shipmentType\n  displayCustomsType\n  freeWarehousingDays\n  costWarehousingPerDay\n  estimatedCostWarehousing\n  estimatedRevenueWarehousing\n  costWarehousing\n  revenueWarehousing\n  estimatedCustomsDuties\n  customsDuties\n  estimatedCustomsVat\n  customsVat\n  costDischarge\n  revenueDischarge\n  costTransport\n  revenueTransport\n  costExpenses\n  revenueExpenses\n  costCustomsInspection\n  revenueCustomsInspection\n  costClimaCertificate\n  revenueClimaCertificate\n  costOpinion\n  revenueOpinion\n  costContainerXray\n  revenueContainerXray\n  costContainerHandling\n  revenueContainerHandling\n  costShipping\n  revenueShipping\n  costCleaning\n  revenueCleaning\n  costSpecialHandling\n  revenueSpecialHandling\n  costStorage\n  revenueStorage\n  costOther\n  costForklift\n  revenueForklift\n  revenueCustomsClearance\n  costCustomsClearance\n  discount\n  discountRemark\n  receivedPayment\n  totalCustomsDutiesAndVat\n  totalMiscRevenue\n  totalMiscCost\n  totalContainerRevenue\n  totalContainerCost\n  totalCost\n  totalRevenue\n  displayExpectedHandoverDate\n  displayHandoverDate\n  displayDischargeDate\n  shipmentValue\n  shippingCost\n  shipmentValueCurrency\n  shipmentTypeDetails {\n    portHandlingCharge\n    vatChargePercent\n    dutiesRatePercent\n  }\n  container {\n    displayTerminalDate\n    costXray\n    costStoragePlusDemurrage\n    costCleaning\n    warehouseContact {\n      slug\n      name\n      freeWarehousingDays\n      costWarehousingPerDay\n      costShipmentDischarge\n      id\n    }\n    id\n  }\n  rateCardContact {\n    slug\n    name\n    rateCard {\n      threePackCarDischarge\n      forklift\n      standardCustomsClearance\n      specialHandling\n      freeWarehousingDays\n      costWarehousing\n    }\n    id\n  }\n  customer {\n    slug\n    vatWarehousing\n    vatRevenues\n    id\n  }\n}\n\nfragment ShipmentFinanceMetricCard_shipment on Shipment {\n  slug\n  totalCost\n  totalRevenue\n  totalProfit\n  shipmentTypeDetails {\n    vatChargePercent\n  }\n  estimatedRevenueWarehousing\n  vatCalculator\n  lexofficeInvoiceAmountPaid\n}\n\nfragment ShipmentRateCard_shipment on Shipment {\n  rateCardContact {\n    name\n    rateCardItem {\n      title\n      keyFields {\n        key\n        ...KeyField_data\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment ShipmentSiblingCompositionCard_shipment on Shipment {\n  container {\n    composition {\n      totalShipments\n      shipmentCountsByType {\n        type\n        typeLabel\n        count\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '0189ff16d785dc6b58b226d480f4c59c';
export default node;
